import type { PageGroup } from '../pageGroup';
import type { PageGroupItemViewModel } from '@trinnvis/dabih-api-client';

export function flattenPageGroups(pageGroups: PageGroup[]): PageGroupItemViewModel[] {
  const pages: PageGroupItemViewModel[] = [];
  pageGroups.forEach((group) => {
    group.pages.forEach((page) => {
      pages.push(page);
    });
  });
  return pages;
}
